/**
 * Reported as `openedVia`. The UI hangs it off each table column, the events filter on it — one
 * declaration for both, or a new column reports a value nothing filters on.
 */
// eslint-disable-next-line import/prefer-default-export
export const COHORT_OPEN_SOURCES = {
  METRIC: 'metric',
  COHORT: 'cohort',
  CLIENTS_TOTAL: 'clients_total',
  CLIENTS_SERVED: 'clients_served',
};
